export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    // dev: 'http://localhost:6830',
    // pro: 'http://localhost:6830'
    // 2.0
    dev: 'http://182.92.232.25:6830',
    pro: 'http://182.92.232.25:6830'
    // 北沙滩
    // dev: 'http://182.92.232.25:6840',
    // pro: 'http://182.92.232.25:6840'
    // 盛科瑞
    // dev: 'http://182.92.232.25:6820',
    // pro: 'http://182.92.232.25:6820'
  },
  baseUr: {
    // 2.0
    dev: 'ws://182.92.232.25:6710',
    pro: 'ws://182.92.232.25:6710'
    // 盛科瑞
    // dev: 'ws://182.92.232.25:6712',
    // pro: 'ws://182.92.232.25:6712'
  },
  build: {
    assetsSubDirectory: 'static',
    assetsPublicPath: './'
    // productionSourceMap:true,
    // productionGzip: false,
    // productionGzipExtensions: ['js', 'css'],
    // bundleAnalyzerReport: process.env.npm_config_report,
    // proxyTable: {},
  },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'home',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: false // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  }
}
